export enum SelectAgenteResultStatus {
  SUCCESS, ERROR, CANCELED
}
